<template>
<div>
    <div v-for="(item, i) in data" :key="i">
          <div v-if="item.products.length > 0" class="storeHeading">
            <h2>{{ item.name }}</h2>
          </div>
          <!-- v-if="this.category.length" -->

          <div
            v-if="item.products.length > 0"
            class="text-center product-slider featuredProducts"
          >
            <div>
              <div class="carousel slide w-100">
                <slick ref="slickthree" :options="slickOptions3">
                  <!-- v-for="(article,index) of category" :key="index" -->
                  <div
                    class=""
                    v-for="(article, index) of item.products"
                    :key="index"
                  >
                    <div class="slide-box">
                      <div class="product-box">
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: { store: article.store },
                          }"
                        >
                          <img
                            :src="article.image"
                            :alt="article.name"
                            :title="article.name"
                          />
                        </router-link>
                      </div>
                      <p>
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: { store: article.store },
                          }"
                          v-text="article.name"
                        ></router-link>
                      </p>
                      <!-- v-if="article.selling_price != article.price" -->
                      <div class="price">
                        <p>
                          <span
                            class="price"
                          >{{ article.selling_price | formatMoney}}</span>
                          <span
                            class="old-price"
                          > {{article.price | formatMoney}}
                          </span>
                          <span
                            v-if="article.selling_price != article.price"
                            class="discount_percent font-bold"
                          >{{ $root.percentOff(article.price,article.selling_price)}}</span
                          >
                        </p>
                      </div>
                      <!-- <div class="price" v-else>
                                    <p><span class="price" v-text="'Rs. '+article.selling_price"></span></p>
                                </div> -->
                    </div>
                  </div>
                </slick>
              </div>
            </div>
          </div>
        </div>
</div>
</template>
<script>
export default {
    props:['data'],
    data(){
        return{
            slickOptions3: {
        slidesToShow: 6,
        arrows: true,

        responsive: [
          {
            breakpoint: 997,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "50px",
            },
          },
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "50px",
            },
          },
        ],
        // Any other options that can be got from plugin documentation
      },
        }
    }
}
</script>